import {
    GET_INVENTORY_LISTING,
    GET_INVENTORY_LISTING_SUCCESS,
    GET_INVENTORY_LISTING_FAIL,
    GET_INVENTORY_DETAILS,
    GET_INVENTORY_DETAILS_SUCCESS,
    GET_INVENTORY_DETAILS_FAIL,
    ADD_INVENTORY,
    ADD_INVENTORY_SUCCESS,
    ADD_INVENTORY_FAIL,
    UPDATE_INVENTORY,
    UPDATE_INVENTORY_SUCCESS,
    UPDATE_INVENTORY_FAIL,
    UPDATE_LOWTHRESHOLD,
    UPDATE_LOWTHRESHOLD_SUCCESS,
    UPDATE_LOWTHRESHOLD_FAIL,
    EXPORT_INVENTORY,
    EXPORT_INVENTORY_SUCCESS,
    EXPORT_INVENTORY_FAIL,
    EXPORT_INVENTORY_LOG,
    EXPORT_INVENTORY_LOG_SUCCESS,
    EXPORT_INVENTORY_LOG_FAIL,
    RESET_INVENTORY_STATE,
    RESET_INVENTORY_ATTACHMENT_STATE,
} from "./actionTypes";

export const getInventoryListing = (payload) => ({
    type: GET_INVENTORY_LISTING,
    payload: payload
});

export const getInventoryListingSuccess = categories => ({
    type: GET_INVENTORY_LISTING_SUCCESS,
    payload: categories,
});

export const getInventoryListingFail = error => ({
    type: GET_INVENTORY_LISTING_FAIL,
    payload: error,
});

export const getInventoryDetails = inventoryId => ({
    type: GET_INVENTORY_DETAILS,
    payload: inventoryId,
});

export const getInventoryDetailsSuccess = inventory => ({
    type: GET_INVENTORY_DETAILS_SUCCESS,
    payload: inventory,
});

export const getInventoryDetailsFail = error => ({
    type: GET_INVENTORY_DETAILS_FAIL,
    payload: error,
});

export const createInventory = inventory => ({
    type: ADD_INVENTORY,
    payload: inventory,
});

export const createInventorySuccess = inventory => ({
    type: ADD_INVENTORY_SUCCESS,
    payload: inventory,
});

export const createInventoryFail = error => ({
    type: ADD_INVENTORY_FAIL,
    payload: error,
});

export const updateInventory = inventory => ({
    type: UPDATE_INVENTORY,
    payload: inventory,
});

export const updateInventorySuccess = inventory => ({
    type: UPDATE_INVENTORY_SUCCESS,
    payload: inventory,
});

export const updateInventoryFail = error => ({
    type: UPDATE_INVENTORY_FAIL,
    payload: error,
});

export const updateLowTreshold = inventoryId => ({
    type: UPDATE_LOWTHRESHOLD,
    payload: inventoryId,
});

export const updateLowTresholdSuccess = inventoryId => ({
    type: UPDATE_LOWTHRESHOLD_SUCCESS,
    payload: inventoryId,
});

export const updateLowTresholdFail = error => ({
    type: UPDATE_LOWTHRESHOLD_FAIL,
    payload: error,
});

export const exportInventory = (payload) => ({
    type: EXPORT_INVENTORY,
    payload: payload
});

export const exportInventorySuccess = data => ({
    type: EXPORT_INVENTORY_SUCCESS,
    payload: data,
});

export const exportInventoryFail = error => ({
    type: EXPORT_INVENTORY_FAIL,
    payload: error,
});

export const exportInventoryLog = (payload) => ({
    type: EXPORT_INVENTORY_LOG,
    payload: payload
});

export const exportInventoryLogSuccess = data => ({
    type: EXPORT_INVENTORY_LOG_SUCCESS,
    payload: data,
});

export const exportInventoryLogFail = error => ({
    type: EXPORT_INVENTORY_LOG_FAIL,
    payload: error,
});

//reset
export const resetInventoryState = () => {
    return {
        type: RESET_INVENTORY_STATE,
    }
}
//reset attachment
export const resetInventoryAttachmentState = () => {
    return {
        type: RESET_INVENTORY_ATTACHMENT_STATE,
    }
}

